export const USER_DESCRIPTION_MAX_LENGTH = 1000;
